import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { DataTable } from 'primereact/datatable';
import axios from 'axios';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from "primereact/button";
import { Dialog } from 'primereact/dialog';
import { Toolbar } from 'primereact/toolbar';
import { Paginator } from 'primereact/paginator';
import { Link } from "react-router-dom";
import LoadingSpinner from "../Spinner/LoadingSpinner";
import { MultiSelect } from 'primereact/multiselect';
import { InputText } from 'primereact/inputtext';
import exportData from "../../services/exportToExcelService";
import AccessControl from "../AccessControl";
import NoAccess from "../NoAccess";
import { RowsPerPageDropdown } from "../../enums/RowsPerPageOptions";
import { Tooltip } from 'primereact/tooltip';
import { Dropdown } from 'primereact/dropdown';

const Company = (props) => {

    // Hooks
    const [Companylist, setCompanylist] = useState([]);
    const [company, setCompany] = useState([]);
    const [id, setid] = useState('');
    const [totalRecords, setTotalRecords] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [fullName, setfullName] = useState(null);
    const [filterContactPerson, setFilterContactPerson] = useState(null);
    const [filterEmail, setFilterEmail] = useState(null);
    const [filterMobileNo, setFilterMobileNo] = useState(null);
    const [filterNoOfDoctor, setFilterNoOfDoctor] = useState(null);

    // Flags
    const [deleteDialog, setdeleteDialog] = useState(false);  // Deleting New Company
    const [enableFilter, setEnableFilter] = useState(false);
    const [filterDialog, setFilterDialog] = useState(false);

    // Const
    const toast = useRef(null);
    const dt = useRef(null);
    const lazyState = useRef({
        first: 0,
        rows: RowsPerPageDropdown[0],
        page: 1,
        sortField: null,
        sortOrder: 1,
        name: null,
        contactperson: null,
        email: null,
        phone: null,
        noofdoctor: null
    }); // For Sorting And Pagination Purpose

    // On Screen Load
    useEffect(() => {
        if (props?.location.state?.detail == "AddCompany") {
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'New Company Added', life: 3000 });
        }
        if (props?.location.state?.detail == "UpdateCompany") {
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Company Updated', life: 3000 });
        }
        getcompanylist();
        document.documentElement.style.setProperty('overflow', 'hidden')
    }, []);


    // - All Api

    // Get All Company
    const getcompanylist = (event, isExportExcel = false) => {
        setIsLoading(true);
        if (!isExportExcel) setCompanylist([]);
        axios.post('/api/Company/GetAll', {
            PaginationRequired: !isExportExcel,
            SortDirection: lazyState.current.sortOrder,
            PageSize: lazyState.current.rows,
            CurrentPageNumber: event && event.rows ? ((event.first / event.rows) + 1) : lazyState.current.page,
            SortField: event ? event.sortField : "",
            Name: lazyState.current.name ? lazyState.current.name.trim() : null,
            Email: lazyState.current.email ? lazyState.current.email.trim() : null,
            Contactperson: lazyState.current.contactperson ? lazyState.current.contactperson.trim() : null,
            Phone: lazyState.current.phone ? lazyState.current.phone.trim() : null,
            Noofdoctor: lazyState.current.noofdoctor ? lazyState.current.noofdoctor.trim() : null,
        }).then(Response => {
            let tempData = [];
            for (let dataObj of Response.data.data) {
                let allExcelData;
                let excelcolumnData = {
                    Id: dataObj.id,
                    Name: dataObj.name,
                    "Contact Person": dataObj.contactperson,
                    Email: dataObj.email,
                    "Mobile No": dataObj.phone,
                    "No. of Doctor": dataObj.noofdoctor,
                };
                if (selectedColumns.length > 0) {
                    for (let selectedColumn of selectedColumns) {
                        let fieldName = selectedColumn.field;
                        let headerName = selectedColumn.header;
                        excelcolumnData = { ...excelcolumnData, [headerName]: dataObj[fieldName] }
                    };
                    tempData.push(excelcolumnData);
                } else {
                    allExcelData = {
                        Id: dataObj.id,
                        Name: dataObj.name,
                        "Contact Person": dataObj.contactperson,
                        Email: dataObj.email,
                        "Mobile No": dataObj.phone,
                        "No. of Doctor": dataObj.noofdoctor,
                    };
                    tempData.push(allExcelData);
                };
            };
            if (isExportExcel) {
                exportData(tempData, 'Company');
                setIsLoading(false);
                return false;
            };
            setTotalRecords(Response.data.totalRecords);
            setCompanylist(Response.data.data);
            setIsLoading(false);
        }).catch((error) => {
            setIsLoading(false);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Oops! Something Went Wrong!', life: 3000 });
        });
    };

    // Get By Id
    const getCompanyDetailsById = (id) => {
        setIsLoading(true);
        axios.get('/api/Company/GetAsync/' + id)
            .then((Response) => {
                setid(Response.data.id);
                setIsLoading(false);
            }).catch((error) => {
                setIsLoading(false);
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Oops! Something Went Wrong!', life: 3000 });
            });
    };

    // To Delete Company
    const deleteCompany = () => {
        setIsLoading(true);
        axios.delete('/api/Company/Delete/' + id)
            .then((result) => {
                if (result.status === 200) {
                    setdeleteDialog(false);
                    getcompanylist(lazyState.current, false);
                    setIsLoading(false);
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Company Deleted', life: 3000 });
                    // document.documentElement.style.setProperty('overflow', 'auto')
                };
            }).catch((error) => {
                setIsLoading(false);
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Oops! Something Went Wrong!', life: 3000 });
            });
    };

    // Functions
    // On Delete Company
    const confirmDeleteCompany = (company) => {
        document.documentElement.style.setProperty('overflow', 'hidden')
        setdeleteDialog(true);
        setCompany(company);
        getCompanyDetailsById(company.id);
    };

    // On Hide Delete Dialog
    const hideDeleteDialog = () => {

        setdeleteDialog(false);
    };

    // For Sorting 
    const onSort = (event) => {
        lazyState.current.sortField = event.sortField;
        lazyState.current.sortOrder = event.sortOrder;
        lazyState.current.first = event.first;
        lazyState.current.rows = event.rows;
        getcompanylist(lazyState.current, false);
    };

    //pagination
    const onBasicPageChange = (event) => {
        // const newPage = event.first / event.rows + 1;
        // if (newPage !== lazyState.current.first / lazyState.current.rows + 1) {
            setIsLoading(true);
            lazyState.current.sortField = lazyState.current.sortField;
            lazyState.current.sortOrder = lazyState.current.sortOrder;
            lazyState.current.first = event.first;
            lazyState.current.rows = event.rows;
            getcompanylist(lazyState.current, false);
            setIsLoading(false);
        // };
    };

    //Template for pagination
    const template2 = {
        layout: ' CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown',
        'CurrentPageReport': (options) => {
            return (
                <span className="paginator-current-report" style={{ color: 'var(--text-color)', userSelect: 'none', textAlign: 'center' }}>
                    Showing {options.first} to {options.last} of {options.totalRecords} entries
                </span>
            );
        },
        RowsPerPageDropdown: (options) => {
            return <span className="paginator-rows-per-page">Items Per Page :<Dropdown value={options.value} options={RowsPerPageDropdown} onChange={options.onChange} /></span>;
        },
    };

    // All Buttons

    // Edit And Delete Buttons
    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <AccessControl
                    allowedPermissions={["delete:company"]}>
                    <Button icon="fa fa-trash" className="p-button-rounded" onClick={() => confirmDeleteCompany(rowData)} tooltip="Delete" tooltipOptions={{ position: "bottom", className: "showtooltip" }} outlined />
                </AccessControl>
            </div>
        );
    };

    // Delete Confirmation Button
    const deleteProductDialogFooter = (
        <>
            <Button label="Yes" icon="pi pi-check" onClick={() => deleteCompany(id)} outlined />
            <Button label="No" autoFocus icon="pi pi-times" onClick={() => hideDeleteDialog(false)} outlined />
        </>
    );

    // Left Side Toolbar
    const leftToolbarTemplate = () => {
        return (
            <div className="admin-toolbar-left my-2">
                <AccessControl
                    allowedPermissions={["add:company"]}>
                    <Link to={'/home/addcompany'}> <Button label="Add Company"
                        icon="fa fa-plus" outlined /> </Link>
                </AccessControl>
            </div>
        );
    };

    const removeFilter = () => {
        lazyState.current.name = null;
        setfullName(null);
        lazyState.current.email = null;
        setFilterEmail(null);
        lazyState.current.phone = null;
        setFilterMobileNo(null);
        lazyState.current.noofdoctor = null;
        setFilterNoOfDoctor(null);
        lazyState.current.contactperson = null;
        setFilterContactPerson(null);
        getcompanylist(lazyState.current, false);
    };

    // Right Side Toolbar
    const rightToolbarTemplate = () => {
        return (
            <div className="admin-toolbar-right my-2">
                {header}
                <Button
                    icon="pi pi-filter"
                    label="Filter"
                    className="p-button-outlined mr-2 mobile-only-btn"
                    onClick={() => setFilterDialog(true)}
                    tooltip="Filter"
                    tooltipOptions={{ position: "bottom", className: "showtooltip" }}
                    outlined
                />
                <Button disabled={lazyState.current.name == null && lazyState.current.email == null && lazyState.current.phone == null &&
                    lazyState.current.noofdoctor == null && lazyState.current.contactperson == null ? true : false}
                    icon="pi pi-filter-slash" className="mr-2" onClick={() => removeFilter()} tooltip="Reset Filter" tooltipOptions={{ position: "bottom", className: "showtooltip" }} outlined></Button>
                <AccessControl
                    allowedPermissions={["export:company"]}>
                    <Button disabled={!(Companylist != null && Companylist.length > 0)} tooltip="Export Excel" tooltipOptions={{ position: "bottom", className: "showtooltip" }} onClick={() => { getcompanylist(null, true); }} icon="pi pi-file-excel" outlined />
                </AccessControl>
            </div>
        );
    };

    // For Email
    const ButtonMailto = (rowData) => {
        return (
            <Link className='linkcolors' id='mailto'
                to='#'
                onClick={(e) => {
                    window.location.href = `mailto:${rowData.email}`;
                    e.preventDefault();
                }}
            >{rowData.email}
            </Link>
        );
    };

    // For Phone Number
    const ButtonPhoneto = (rowData) => {
        return (
            <Link className='linkcolors' id='callto'
                to='#'
                onClick={(e) => {
                    window.location.href = `tel:${rowData.phone}`;
                    e.preventDefault();
                }}
            >{rowData.phone}
            </Link>
        );
    };

    const hidecolumns = [
        { field: "address", header: "Address" },
        { field: "remarks", header: "Remarks" },
    ];

    const onColumnToggle = (event) => {
        let selectedColumns = event.value;
        let orderedSelectedColumns = hidecolumns.filter(col => selectedColumns.some(sCol => sCol.field === col.field));
        setSelectedColumns(orderedSelectedColumns);
    };

    const header = (
        <MultiSelect className="more-columns-multiselect" value={selectedColumns} options={hidecolumns} optionLabel="header" placeholder="More Columns" onChange={onColumnToggle} display="chip" />
    );

    const sortColumn = {
        "Address": 'Address',
        "Remarks": 'Remarks',
    };

    const hidecolumnComponents = selectedColumns.map(col => {
        return <Column key={col.field} style={{ overflowWrap: 'anywhere' }} field={col.field} header={col.header} sortable headerStyle={col.header == 'Address' ? { width: '15%', minWidth: '15rem' } : { width: '15%', minWidth: '15rem' }} sortField={sortColumn[col.header]} />;
    });

    const FilterOnEnter = (e) => {
        if (e.key == "Enter") {
            if (e.target.value.trim() != null && e.target.value.trim() != "") {
                setIsLoading(true);
                let data = e.target.id;
                switch (data) {
                    case "fullName":
                        lazyState.current.contactperson = e.target.value ? e.target.value : null
                        break;

                    case "company":
                        lazyState.current.name = e.target.value ? e.target.value : null
                        break;

                    case "Email":
                        lazyState.current.email = e.target.value ? e.target.value : null
                        break;

                    case "MobileNo":
                        lazyState.current.phone = e.target.value ? e.target.value : null
                        break;

                    case "Noofdoctor":
                        lazyState.current.noofdoctor = e.target.value ? e.target.value : null
                        break;
                };
                getcompanylist(lazyState.current, false,);
                setIsLoading(false);
            } else {
                setIsLoading(true);
                let data = e.target.id;
                switch (data) {
                    case "fullName":
                        lazyState.current.contactperson = null;
                        break;

                    case "company":
                        lazyState.current.name = null;
                        break;

                    case "Email":
                        lazyState.current.email = null;
                        break;

                    case "MobileNo":
                        lazyState.current.phone = null;
                        break;

                    case "Noofdoctor":
                        lazyState.current.noofdoctor = null;
                        break;
                };
                getcompanylist(lazyState.current, false,);
                setIsLoading(false);
            };
        };
    };

    const UserFilterTemplate = () => {
        return (
            <InputText id="company" required autoFocus value={fullName} placeholder="Enter Company Name" style={{ overflowWrap: 'anywhere' }}
                onChange={(e) => setfullName(e.target.value)} onKeyDown={(e) => FilterOnEnter(e)} className="company-filter-input" />
        );
    };

    const ContactPersonFilterTemplate = () => {
        return (
            <InputText id="fullName" required value={filterContactPerson} placeholder="Enter Contact Person"
                onChange={(e) => setFilterContactPerson(e.target.value)} onKeyDown={(e) => FilterOnEnter(e)} className="company-filter-input" />
        );
    };

    const EmailFilterTemplate = () => {
        return (
            <InputText id="Email" required value={filterEmail} placeholder="Enter Email"
                onChange={(e) => setFilterEmail(e.target.value)} onKeyDown={(e) => FilterOnEnter(e)} className="company-filter-input" />
        );
    };

    const MobileFilterTemplate = () => {
        return (
            <InputText id="MobileNo" required value={filterMobileNo} placeholder="Enter Mobile no"
                onChange={(e) => setFilterMobileNo(e.target.value)} onKeyDown={(e) => FilterOnEnter(e)} className="company-filter-input" />
        );
    };

    const NoOfDoctorFilterTemplate = () => {
        return (
            <InputText id="Noofdoctor" required value={filterNoOfDoctor} placeholder="Enter No of Doctor"
                onChange={(e) => setFilterNoOfDoctor(e.target.value)} onKeyDown={(e) => FilterOnEnter(e)} className="company-filter-input" />
        );
    };

    const ViewCompany = (rowData) => {
        return (
            <Link className='linkcolors' id='viewcompany'
                tooltip='aa'
                to='#'
                onClick={(e) => {
                    history.push('/home/viewcompany/' + rowData.id)
                }}
            >{rowData.name}
            </Link>
        );
    };

    const SearchFilter = () => {
        lazyState.current.name = fullName ? fullName : null;
        lazyState.current.contactperson = filterContactPerson ? filterContactPerson : null;
        lazyState.current.email = filterEmail ? filterEmail : null;
        lazyState.current.phone = filterMobileNo ? filterMobileNo : null;
        lazyState.current.noofdoctor = filterNoOfDoctor ? filterNoOfDoctor : null;
        getcompanylist(lazyState.current, false);
        setFilterDialog(false);
    };

    const filterDialogFooter = (
        <div className="filter-modal-actions" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '0.5rem' }}>
            <Button
                label="Reset"
                icon="pi pi-filter-slash"
                className="p-button-outlined p-button-secondary"
                onClick={() => {
                    removeFilter();
                    setFilterDialog(false);
                }}
                outlined
            />
            <Button
                label="Apply"
                icon="pi pi-check"
                className="p-button-primary"
                onClick={() => SearchFilter()}
            />
        </div>
    );

    return (
        <AccessControl
            allowedPermissions={["list:company"]}
            renderNoAccess={() => <NoAccess />}
        >
            <div className="trico-Grid">
                <Toast ref={toast} />
                {isLoading ? <LoadingSpinner /> :
                    (
                        <>
                            <div className="p-col">
                                <div className="card">
                                    <h5 className="headerfont"><span><i className="fa fa-solid fa-building mr-2"></i>Company</span></h5>
                                    <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate} className="mb-3"></Toolbar>
                                    <Tooltip target="#viewcompany" content="View Company" />
                                    <Tooltip target="#mailto" content="Mail To" />
                                    <Tooltip target="#callto" content="Call To" />
                                    <div className="attendee-status-desktop-table">
                                        <DataTable size="small" stripedRows ref={dt} value={Companylist}
                                            lazy rows={lazyState.current.rows} scrollHeight="calc(100vh - 250px)" scrollable
                                            onSort={onSort} sortField={lazyState.current.sortField} sortOrder={lazyState.current.sortOrder}
                                            removableSort
                                            className="datatable-responsive company-datatable admin-datatable" responsiveLayout="scroll"
                                            filterDisplay={"row"}>
                                            <Column body={ViewCompany} sortField="Name" field="name" header="Name" sortable headerStyle={{ width: '25%', minWidth: '16rem' }} style={{ overflowWrap: 'anywhere' }} filter showFilterMenu={false} filterElement={UserFilterTemplate}></Column>
                                            <Column field="contactperson" header="Contact Person" sortField="Firstname" sortable headerStyle={{ width: '15%', minWidth: '13rem' }} style={{ overflowWrap: 'anywhere' }} filter showFilterMenu={false} filterElement={ContactPersonFilterTemplate}></Column>
                                            <Column body={ButtonMailto} header="Email" sortable sortField="Email" headerStyle={{ width: '15%', minWidth: '13rem' }} filter showFilterMenu={false} style={{ overflowWrap: 'anywhere' }} filterElement={EmailFilterTemplate}></Column>
                                            <Column body={ButtonPhoneto} header="Phone" sortField="Phone" sortable headerStyle={{ width: '15%', minWidth: '11rem' }} filter showFilterMenu={false} style={{ overflowWrap: 'anywhere' }} filterElement={MobileFilterTemplate}></Column>
                                            <Column field="noofdoctor" header="No. Of Doctors" sortField="Noofdoctor" sortable style={{ width: "5px", overflowWrap: 'anywhere' }} headerStyle={{ width: '15%', minWidth: '10rem' }} filter showFilterMenu={false} filterElement={NoOfDoctorFilterTemplate}></Column>
                                            {hidecolumnComponents}
                                            <Column header="Action" body={actionBodyTemplate} style={{ overflowWrap: 'anywhere' }} headerStyle={{ width: '10px%', minWidth: '8rem' }}></Column>
                                        </DataTable>
                                    </div>
                                    <div className="attendee-status-mobile-cards">
                                        <div className="attendee-card-grid">
                                            {Companylist && Companylist.length > 0 ? (
                                                Companylist.map((row) => {
                                                    return (
                                                        <div key={row.id} className="attendee-mobile-card">
                                                            {/* Top header with Company Badge, Doctors count and Actions */}
                                                            <div className="attendee-card-top flex justify-content-between align-items-center mb-2">
                                                                <div className="attendee-card-top-left flex flex-wrap align-items-center gap-2">
                                                                    <span className="attendee-company-badge">
                                                                        <i className="fa fa-building-o mr-1"></i>Company
                                                                    </span>
                                                                    {row.noofdoctor != null && (
                                                                        <span className="batch-tag">
                                                                            <i className="fa fa-user-md mr-1"></i>Doctors: {row.noofdoctor}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                                <div className="attendee-card-top-right flex align-items-center">
                                                                    {actionBodyTemplate(row)}
                                                                </div>
                                                            </div>

                                                            {/* Full Name */}
                                                            <h6 className="attendee-card-name font-bold mb-2">
                                                                {ViewCompany(row)}
                                                            </h6>

                                                            {/* Contact Person */}
                                                            {row.contactperson && (
                                                                <div className="attendee-card-subinfo text-sm mb-2 text-600">
                                                                    <span className="designation-pill">
                                                                        <i className="fa fa-user mr-1"></i>{row.contactperson}
                                                                    </span>
                                                                </div>
                                                            )}

                                                            {/* Details Section */}
                                                            <div className="attendee-card-details">
                                                                {(row.email || row.phone) && (
                                                                    <div className="attendee-detail-row">
                                                                        {row.phone && (
                                                                            <div className="attendee-detail-item">
                                                                                <i className="fa fa-phone text-500 mr-1"></i>
                                                                                {ButtonPhoneto(row)}
                                                                            </div>
                                                                        )}
                                                                        {row.email && (
                                                                            <div className="attendee-detail-item">
                                                                                <i className="fa fa-envelope-o text-500 mr-1"></i>
                                                                                {ButtonMailto(row)}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                )}
                                                                {(row.address || row.remarks) && (
                                                                    <div className="attendee-detail-row">
                                                                        {row.address && (
                                                                            <div className="attendee-detail-item">
                                                                                <i className="fa fa-map-marker text-500 mr-1"></i>
                                                                                <span className="text-sm">Address: {row.address}</span>
                                                                            </div>
                                                                        )}
                                                                        {row.remarks && (
                                                                            <div className="attendee-detail-item">
                                                                                <i className="fa fa-comment-o text-500 mr-1"></i>
                                                                                <span className="text-sm">Remarks: {row.remarks}</span>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    );
                                                })
                                            ) : (
                                                <div className="attendee-empty-state text-center p-4 card surface-card">
                                                    <i className="fa fa-inbox text-4xl text-400 mb-2"></i>
                                                    <p className="text-600 m-0">No records found</p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <Paginator className='justify-content-end company-paginator admin-paginator' first={lazyState.current.first} rows={lazyState.current.rows} totalRecords={totalRecords} template={template2} rowsPerPageOptions={RowsPerPageDropdown} onPageChange={onBasicPageChange} ></Paginator>

                                    <Dialog visible={deleteDialog} draggable={false} style={{ width: '450px', maxWidth: '95vw' }}
                                        breakpoints={{ '960px': '75vw', '640px': '92vw' }}
                                        header="Confirm" modal className="company-dialog admin-dialog" footer={deleteProductDialogFooter} onHide={hideDeleteDialog}>
                                        <div className="flex align-items-center">
                                            <i className="fa fa-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                                            <span>Are you sure you want to delete <b>{company.name}</b> company?</span>
                                        </div>
                                    </Dialog>

                                    <Dialog
                                        visible={filterDialog}
                                        draggable={false}
                                        header={
                                            <div className="dialog-header-content flex align-items-center gap-2">
                                                <i className="fa fa-filter text-primary dialog-header-icon mr-2"></i>
                                                <span className="dialog-header-title">Filter Company</span>
                                            </div>
                                        }
                                        modal
                                        className="p-fluid admin-dialog attendee-filter-dialog"
                                        footer={filterDialogFooter}
                                        onHide={() => setFilterDialog(false)}
                                    >
                                        <div className="filter-dialog-grid">
                                            <div className="filter-field-item">
                                                <label>Company Name</label>
                                                <InputText value={fullName} placeholder="Enter Company Name" onChange={(e) => setfullName(e.target.value)} />
                                            </div>
                                            <div className="filter-field-item">
                                                <label>Contact Person</label>
                                                <InputText value={filterContactPerson} placeholder="Enter Contact Person" onChange={(e) => setFilterContactPerson(e.target.value)} />
                                            </div>
                                            <div className="filter-field-item">
                                                <label>Email</label>
                                                <InputText value={filterEmail} placeholder="Enter Email" onChange={(e) => setFilterEmail(e.target.value)} />
                                            </div>
                                            <div className="filter-field-item">
                                                <label>Mobile No</label>
                                                <InputText value={filterMobileNo} placeholder="Enter Mobile no" onChange={(e) => setFilterMobileNo(e.target.value)} />
                                            </div>
                                            <div className="filter-field-item">
                                                <label>No of Doctor</label>
                                                <InputText value={filterNoOfDoctor} placeholder="Enter No of Doctor" onChange={(e) => setFilterNoOfDoctor(e.target.value)} />
                                            </div>
                                        </div>
                                    </Dialog>
                                </div>
                            </div>
                        </>
                    )
                }
            </div>
        </AccessControl>
    );
};

export default Company;